export function computeSceneMetrics(objects) {
  const box = new THREE.Box3();
  objects.forEach(o => box.expandByObject(o));

  return {
    center: box.getCenter(new THREE.Vector3()),
    size:   box.getSize(new THREE.Vector3()).length()
  };
}
